import { logError, logWarning } from './datadogRUM';

export const tryParseJSON = (string) => {
  try {
    if (typeof string !== 'string' || string.length === 0) return false;
    const result = JSON.parse(string);
    return result;
  } catch (error) {
    // if the string is not 'FALSE' log the error to Datadog
    // to reduce noise
    if (string !== 'FALSE') {
      // log error to Datadog
      logError({
        error,
        message: 'failed to parse JSON',
        context: {
          input_type: typeof string,
          input_length: string.length,
        },
      });
    }
  }
  return false;
};

export const statusIsOk = (response) => [200, 201].includes(response.status);

const isValidString = (string) =>
  typeof string === 'string' && string.length > 0;

export const getItemsFromList = (listString) => {
  let result = { items: [{ item: '' }] };

  if (isValidString(listString)) {
    try {
      result = JSON.parse(listString);
    } catch (error) {
      // log the error to Datadog
      logError({
        error,
        message: 'failed to parse value in getItemsFromList',
        context: {
          input_type: typeof listString,
          input_length: listString.length,
        },
      });
    }
  } else {
    logWarning('invalid string provided in getItemsFromList', {
      input_type: typeof listString,
    });
  }

  return result;
};
